export const addTopicSiteCoreKeys = {
  addTopic: "MDM.Activity.AddTopic",
  topicDetailsHeader: "Activity.AddTopic.TopicDetails-Header",
  selectTypeSubHeader: "AddTopic.TopicDetails.SelectType-SubHeader",
  existingTopicRadioButton: "AddTopic.TopicDetails.ExistingTopicRadioButton",
  newTopicRadioButton: "AddTopic.TopicDetails.NewTopicRadioButton",
  topicLabel: "AddTopic.TopicDetails.Topic",
  deliverablesLabel: "AddTopic.TopicDetails.Deliverables",
  minutesList: "AddTopic.MinutesList",
  minutesLabel: "AddTopic.TopicDetails.Minutes",
  quantityLabel: "AddTopic.TopicDetails.Quantity",
  numberOfDaysLabel: "AddTopic.TopicDetails.NumberOfDays",
  activityStatusList: "AddTopic.TopicDetails.ActivityStatusList",
  participantStatusList: "AddTopic.TopicDetails.ParticipantStatusList",
  activityStatusLabel: "AddTopic.TopicDetails.ActivityStatus",
  participantStatusLabel: "AddTopic.TopicDetails.ParticipantStatus",
  selectPreferencesSubHeader:
    "AddTopic.TopicDetails.SelectPreferences-SubHeader",
  triggerBilling: "AddTopic.TopicDetails.TriggerBilling",
  triggerTouchPointSurvey: "AddTopic.TopicDetails.TriggerTouchPointSurvey",
  countTowardsLastContactDate:
    "AddTopic.TopicDetails.CountTowardsLastContactDate",
  localeTopicHeader: "Activity.AddTopic.Locale-Topic-Header",
  addExceptionsHeader: "Activity.AddTopic.AddExceptions-Header",
  countryLabel: "AddTopic.AddExceptions.Country",
  actionHeader: "AddTopic.AddExceptions.Action",
  noExceptionsAvailableMessage:
    "AddTopic.AddExceptions.NoExceptionsAvailableMessage",
  discardChangesMessage: "Activity.AddTopic.DiscardChangesMessage",
  addTopicToActivity: "Activity.AddTopic.AddTopicToActivity",
  saveAndAddNewTopicButton: "Activity.AddTopic.SaveandAddNewTopic-Button",
  topicAddedMessage: "Activity.AddTopic.TopicAddedMessage",
  duplicateTopicErrorMessage: "Activity.AddTopic.DuplicateTopicErrorMessage",
  topicNameLabel: "AddTopic.TopicDetails.TopicName",
  viewTopicHeader: "Activity.AddTopic.ViewTopicHeader",
  editTopicLink: "Activity.AddTopic.EditTopicLink",
  halfDayLabel: "AddTopic.TopicDetails.HalfDay",
  selectedPreferences: "AddTopic.TopicDetails.SelectedPreferences",
  noExceptionsFoundMessage: "AddTopic.AddExceptions.NoExceptionsFoundMessage",
  selectedDeliverables: "AddTopic.TopicDetails.SelectedDeliverables",
  editTopicHeader: "Activity.AddTopic.EditTopicHeader",
  updateTopicButton: "Activity.AddTopic.UpdateTopicButton",
  topicUpdatedMessage: "Activity.AddTopic.TopicUpdatedMessage",
  updateTopicConfirmationMessage:
    "Activity.AddTopic.UpdateTopicConfirmationMessage",
};
